import { Leaf, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { dateBR } from "../../lib/api";

function maskedCpf(cpf = "") {
  const d = cpf.replace(/\D/g, "");
  return d.length === 11 ? `***.${d.slice(3, 6)}.${d.slice(6, 9)}-**` : "—";
}

const STATUS_TXT = { active: "ATIVO", pending: "PENDENTE", blocked: "BLOQUEADO" };

function Field({ label, value, testId }) {
  return (
    <div>
      <p className="text-[9px] tracking-[0.18em] text-emerald-200/80">{label}</p>
      <p className="text-sm font-semibold font-mono" data-testid={testId}>{value}</p>
    </div>
  );
}

export function MemberCard({ member }) {
  return (
    <div
      className="print-area relative w-full max-w-[420px] aspect-[1.586] rounded-2xl p-5 text-white overflow-hidden bg-gradient-to-br from-[#166534] to-[#052E16] shadow-xl flex flex-col justify-between"
      data-testid="member-card"
    >
      <div className="absolute -right-16 -top-16 w-48 h-48 rounded-full bg-white/5" />
      <div className="absolute -right-6 -bottom-20 w-56 h-56 rounded-full bg-emerald-300/10" />
      <div className="relative flex items-start justify-between">
        <div className="flex items-center gap-2">
          <Leaf className="w-5 h-5 text-emerald-300" />
          <span className="font-display font-extrabold leading-none">
            Ressignificar
            <span className="block text-[9px] tracking-[0.2em] text-emerald-300 mt-0.5">BENEFÍCIOS</span>
          </span>
        </div>
        <span className="text-[9px] tracking-[0.18em] text-emerald-200">CARTEIRINHA DIGITAL</span>
      </div>
      <div className="relative">
        <p className="font-display text-lg font-extrabold uppercase leading-tight" data-testid="card-member-name">
          {member.nome_completo}
        </p>
        <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2">
          <Field label="Nº ASSOCIADO" value={member.cadastro_number} testId="card-number-value" />
          <Field label="CPF" value={maskedCpf(member.cpf)} />
          <Field label="NASCIMENTO" value={dateBR(member.data_nascimento)} />
          <Field label="ASSOCIADO DESDE" value={dateBR(member.created_at)} />
        </div>
      </div>
      <div className="relative flex items-end justify-between">
        <span className="text-[10px] font-bold tracking-widest bg-white/15 rounded-full px-2.5 py-1" data-testid="card-status">
          {STATUS_TXT[member.status] || "—"}
        </span>
        <span className="text-[8px] text-emerald-100/70 text-right max-w-[55%] leading-tight">
          Não é plano de saúde nem convênio médico. Consultas cobradas separadamente.
        </span>
      </div>
    </div>
  );
}

export function MemberCardDialog({ member, onClose }) {
  return (
    <Dialog open={!!member} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="member-card-dialog">
        <DialogHeader>
          <DialogTitle>Carteirinha digital</DialogTitle>
        </DialogHeader>
        {member && (
          <div className="flex flex-col items-center gap-4">
            <MemberCard member={member} />
            <Button
              onClick={() => window.print()}
              className="rounded-full bg-[#166534] hover:bg-[#14532d] hover:text-white text-white"
              data-testid="print-card"
            >
              <Printer className="w-4 h-4 mr-2" /> Imprimir / Salvar PDF
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
